/** Filesystem access helpers — wraps backend FS endpoints with typed return shapes. */

import { API_BASE } from '@/design/tokens';

export interface ChildFolder {
  name: string;
  path: string;
}

/** List child folders of a directory by calling the backend FS API. */
export async function listChildFolders(dirPath: string): Promise<ChildFolder[]> {
  const url = `${API_BASE}/api/v1/projects/list-folders`;
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ root_path: dirPath }),
  });
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`API error ${res.status}: ${body}`);
  }
  const data = await res.json();
  return data.folders;
}
